// import React, { useEffect, useState } from 'react';
// import AdminAppBar from '../adminComponents/AdminAppBar';
// import { useNavigate } from "react-router-dom";
// import AppBar from '../leadComponent/AppBar';

// const MyProfile = () => {
//   const [userData, setUserData] = useState({});
//   const [teamData, setTeamData] = useState([]);

  
//   useEffect(() => {
//     // Log local storage content before parsing
//     console.log('Local Storage - userData:', localStorage.getItem('userData'));

//     const storedUserData = localStorage.getItem('userData');

//     if (storedUserData) {
//       const parsedUserData = JSON.parse(storedUserData);
//       console.log('Parsed User Data:', parsedUserData);
//       setUserData(parsedUserData.user);
//       setTeamData(parsedUserData.teamId || []);
//     }
//   }, []);

  

//   useEffect(() => {
//     console.log('Updated Team Data State:', teamData);
//   }, [teamData]);

//   const teamNames = teamData.map(team => team.name).join(', ');
//   return (
//     <div className=' bg-appGrayBackground pt-16 pb-10'>
//       {(userData.role == "Admin" ||userData.role == "MD" || userData.role == "BOD" || userData.role === "CMO"  )? <AdminAppBar/> : <AppBar/> }
      

//       <div>
//         <div className="bg-appGrayBackground">
          

          

//           <div className="flex items-center gap-7    mt-10">
//           <div className=" ">
      
//           </div>
//           <div className="text-3xl font-bold mt-1 4xl:text-4xl ">
//             Your Profile
//           </div>
//         </div>
           

//         {/* 4xl:w-full 4xl:h-[650px] w-full  shadow-md rounded flex flex-col gap-6 3xl:w-10/12  md:px-4 lg:px-8 lg:pt-7 md:pt-6 md:pb-4 lg:pb-8 md:mt-8 lg:mt-8 md:mx-0 lg:mx-0 md:mb-4  */}

//             <form className="bg-white   shadow-md rounded flex flex-col gap-6 p-12 mx-16 mt-6 4xl:mt-20 4xl:h-[760px]">
//               <div className="mb-8 flex items-center 4xl:mt-16">
//                 <label className="w-1/4 text-gray-700 text-2xl  4xl:text-3xl  font-medium" htmlFor="name">
//                   User Name
//                 </label>
//                 <input
//                   className="shadow appearance-none border rounded  4xl:text-3xl  w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                   id="name"
//                   type="text"
//                   value={userData.name || ''}
//                   readOnly
//                 />
//               </div>

//               <div className="mb-8 flex items-center">
//                 <label className="w-1/4 text-gray-700 text-2xl 4xl:text-3xl  font-medium" htmlFor="role">
//                   Role
//                 </label>
//                 <input
//                   className="shadow appearance-none border rounded 4xl:text-3xl  w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                   id="role"
//                   type="text"
//                   value={userData.role || ''}
//                   readOnly
//                 />
//               </div>

//               {userData.role !== 'Admin' && (
//                 <div className="mb-8 flex items-center">
//                   <label className="w-1/4 text-gray-700 text-2xl 4xl:text-3xl  font-medium" htmlFor="team">
//                     Team
//                   </label>
//                   <div className="shadow appearance-none border 4xl:text-2xl  rounded h-10 w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
//                   {teamData.length > 0 ? (
//                       <div>{teamNames}</div>
//                     ) : (
//                       <div>No team  available</div>
//                     )}


//                   </div>
//                 </div>
//               )}

//               <div className="mb-8 flex items-center">
//                 <label className="w-1/4 text-gray-700 text-2xl 4xl:text-3xl  font-medium" htmlFor="employeeId">
//                   Employee ID
//                 </label>
//                 <input
//                   className="shadow appearance-none border rounded  4xl:text-3xl  w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                   id="employeeId"
//                   type="text"
//                   value={userData.employeeId || ''}
//                   readOnly
//                 />
//               </div>

//               <div className="mb-8 flex items-center">
//                 <label className="w-1/4 text-gray-700 text-2xl 4xl:text-3xl  font-medium" htmlFor="emailId">
//                   Email ID
//                 </label>
//                 <input
//                   className="shadow appearance-none border rounded 4xl:text-3xl  w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                   id="emailId"
//                   type="text"
//                   value={userData.emailId || ''}
//                   readOnly
//                 />
//               </div>

//               <div className="mb-8 flex items-center">
//                 <label className="w-1/4 text-gray-700 text-2xl 4xl:text-3xl  font-medium" htmlFor="phoneNumber">
//                   Phone Number
//                 </label>
//                 <input
//                   className="shadow appearance-none border rounded 4xl:text-3xl  w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                   id="phoneNumber"
//                   type="text"
//                   value={userData.phoneNumber || ''}
//                   readOnly
//                 />
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//   );
// };

// export default MyProfile;
import React, { useEffect, useState } from 'react';
import AdminAppBar from '../adminComponents/AdminAppBar';
import AppBar from '../leadComponent/AppBar';
import CustomHeading from '../common/CustomHeading';
import { FaUserCircle, FaBriefcase, FaUsers, FaIdCard, FaEnvelope, FaPhone, FaCopy } from 'react-icons/fa';


const MyProfile = () => {
  const [userData, setUserData] = useState(null);
  const [teamData, setTeamData] = useState([]);


  
  useEffect(() => {
    // Log local storage content before parsing
    console.log('Local Storage - userData:', localStorage.getItem('userData'));

    const storedUserData = localStorage.getItem('userData');

    if (storedUserData) {
      const parsedUserData = JSON.parse(storedUserData);
      console.log('Parsed User Data:', parsedUserData);
      setUserData(parsedUserData.user);
      setTeamData(parsedUserData.teamId || []);
    }
  }, []);

  

  useEffect(() => {
    console.log('Updated Team Data State:', teamData);
  }, [teamData]);

  const teamNames = teamData.map(team => team.name).join(', ');

  const handleCopy = (value) => {
    navigator.clipboard.writeText(value);
    alert(`${value} copied to clipboard!`);
  };



  if (!userData) {
    return (
      <div className="bg-gray-100 min-h-screen flex items-center justify-center">
      
      </div>
    );
  }

  return (
    <div className="bg-gray-100 min-h-screen pt-16 pb-10 font-sans">
      {(userData.role === 'Admin' || userData.role === 'MD' || userData.role === 'BOD' || userData.role === 'CMO') ? (
        <AdminAppBar />
      ) : (
        <AppBar />
      )}

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-8">
        <CustomHeading title="Your Profile" isIcon={true} />

        <div className="bg-white shadow rounded-[10px] p-6 sm:p-8 mt-6 space-y-6 transition-all duration-300">
          <div className="flex items-center gap-4 border-b pb-4">
          <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center text-green-600 font-bold text-xl">
              {userData.name?.charAt(0) || 'U'}
            </div>
            <div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-800">{userData.name || 'N/A'}</h3>
              <p className="text-sm text-gray-500">{userData.role || ''}</p>
            </div>
          </div>

          <ProfileField
            label="Role"
            value={userData.role || 'N/A'}
            icon={<FaBriefcase className="text-xl text-green-600" />}
            tooltip="Your role in the organization"
          />

          {userData.role !== 'Admin' && (
            <ProfileField
              label="Team"
              value={teamData.length > 0 ? teamNames : 'No team available'}
              icon={<FaUsers className="text-xl text-indigo-600" />}
              tooltip="Teams you are part of"
            />
          )}

          <ProfileField
            label="Employee ID"
            value={userData.employeeId || 'N/A'}
            icon={<FaIdCard className="text-xl text-purple-600" />}
            tooltip="Your unique employee ID"
          />
          <ProfileField
            label="Email ID"
            value={userData.emailId || 'N/A'}
            icon={<FaEnvelope className="text-xl text-red-600" />}
            onCopy={() => handleCopy(userData.emailId)}
            tooltip="Your email address"
          />
          <ProfileField
            label="Phone Number"
            value={userData.phoneNumber || 'N/A'}
            icon={<FaPhone className="text-xl text-yellow-600" />}
            onCopy={() => handleCopy(userData.phoneNumber)}
            tooltip="Your contact number"
          />
        </div>
      </div>
    
    </div>
  );
};

const ProfileField = ({ label, value, icon, onCopy, tooltip }) => (
  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4 hover:bg-gray-50 p-3 rounded-lg transition-colors duration-200">
    <label
      className="w-full sm:w-1/4 text-sm sm:text-base font-semibold text-gray-700 flex items-center gap-2"
    
    >
      {icon} {label}
    </label>
    <div className="w-full sm:w-3/4 flex items-center gap-2">
      <div
        className="w-full bg-gray-50 border border-gray-200 rounded-md px-3 py-2 text-gray-700 text-sm sm:text-base"
        aria-label={`${label}: ${value}`}
      >
        {value}
      </div>
      {onCopy && (
        <button
          onClick={onCopy}
          className="text-gray-500 hover:text-customGreen transition-colors duration-200"
          aria-label={`Copy ${label}`}
        >
          <FaCopy className="text-sm" />
        </button>
      )}
    </div>
  </div>
);

export default MyProfile;